import { ref } from "vue";
import { environmentData } from "@/helper/environment";
import { useExportLocationStore } from "@/store/export/export_location_store";
import { ExportEnquiryServices } from "@/service/export/export_booking_detail_service";
import type { BookingEnquiryInterface, ValidBookingIds } from "@/interface/export/export_booking_detail_interface";
import { storeToRefs } from "pinia";
import { useExportSearchIdsStore } from "@/store/export/export_id_store";

export class ExportEnquiryRepository {
  async getEnquiryDetail(): Promise<BookingEnquiryInterface> {
    const service = new ExportEnquiryServices();
    const searchStore = useExportSearchIdsStore();
    const locationStore = useExportLocationStore();
    const terminalId = locationStore.terminalSelected.id;
    const { getExportSearchIds } = storeToRefs(searchStore);
    const ids = getExportSearchIds.value.join(",");
    const bookings = ref<ValidBookingIds[]>([]);
    const exportAsset = ref<ValidBookingIds[]>([]);

    const url = `${environmentData.domain}/tt-export-booking?assetIds=${ids}&terminal=${terminalId}`;
    const containers: BookingEnquiryInterface = await service.fetchBookingDetail(url);
    try {
      containers.validIds.forEach((item: ValidBookingIds, index: number): void => {
        if (item.isContainer) {
          item.id = index;
          exportAsset.value.push(item);
        } else {
          // Check if booking number is not null and not empty and it does not exist in the bookingNumbers array
          const bk = item.bookingNumber ?? "";
          if (bk != "" && bk != null && !bookings.value.includes(item)) {
            item.id = index;
            bookings.value.push(item);
          }
        }
      });

      const result: BookingEnquiryInterface = {
        bookingIds: bookings.value,
        validIds: exportAsset.value,
        invalidIds: containers.invalidIds
      };
      return result;
    } catch (e) {
      throw Error(e);
    }
  }
}
